/**
 * The institute's own published reach, as its site prints it in the footer of
 * every page (fetched 2026-08-07). Nothing here is inferred: no invented
 * extensions, no toll-free line, no office hours — the source publishes none.
 *
 * The page this feeds replaced a prototype that shipped an invented "233 8xx"
 * exchange, a fabricated toll-free number, literal "Prof. Coord-01" /
 * "Mr. Warden-01" placeholders and made-up office locations. Per-office people
 * are NOT duplicated here — admissionContacts.ts, placementCell.ts,
 * examOffice.ts, library.ts and hostels.ts each own their office's roster, one
 * source per fact.
 *
 * The address is a post box: the source writes "P.O. Box No. 325, Shamanur
 * Road" — the prototype misread that as street number "325, Shamanur Road".
 */

export const INSTITUTE_REACH = {
  name: "Bapuji Institute of Engineering & Technology",
  address: ["P.O. Box 325, Shamanur Road", "Davanagere — 577 004", "Karnataka, India"],
  /** The one telephone line the institute publishes site-wide. */
  phone: "+91 8192 222245",
  fax: ["08192 221461", "08192 220938", "08192 222245"],
  emails: {
    principal: "principal@bietdvg.edu",
    webmaster: "webmaster@bietdvg.edu",
  },
  /** "CAMPUS TOUR" in the institute's own navigation — a YouTube video. */
  tourVideo: "https://youtu.be/-wPxdLMubzY",
  /**
   * OpenStreetMap's own entry for the institute (node on BIET Road,
   * Vinobanagara). The prototype's pin sat ~2 km north-east of campus.
   */
  map: { lat: 14.4444, lon: 75.9028 },
  source: "https://www.bietdvg.edu/",
};

/** OSM embed URL built from the verified pin, ±~1.5 km each way. */
export function mapEmbedUrl(): string {
  const { lat, lon } = INSTITUTE_REACH.map;
  const bbox = [lon - 0.015, lat - 0.012, lon + 0.015, lat + 0.012].join("%2C");
  return `https://www.openstreetmap.org/export/embed.html?bbox=${bbox}&layer=mapnik&marker=${lat}%2C${lon}`;
}

/** Directions to the verified pin, for the "Get directions" CTA. */
export function directionsUrl(): string {
  const { lat, lon } = INSTITUTE_REACH.map;
  return `https://www.google.com/maps/dir/?api=1&destination=${lat}%2C${lon}`;
}
